import React, { useEffect, useState } from 'react';
import { Clock, MapPin, Hash } from 'lucide-react';
import { CaseDetails } from '../types/instruments';
interface HeaderProps {
  caseDetails: CaseDetails;
}
export function Header({
  caseDetails
}: HeaderProps) {
  const [elapsed, setElapsed] = useState('00:00:00');
  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      const diff = now.getTime() - caseDetails.startTime.getTime();
      const hours = Math.floor(diff / 3600000);
      const minutes = Math.floor(diff % 3600000 / 60000);
      const seconds = Math.floor(diff % 60000 / 1000);
      setElapsed(`${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
    }, 1000);
    return () => clearInterval(timer);
  }, [caseDetails.startTime]);
  return <header className="h-20 bg-surface border-b border-border flex items-center justify-between px-8 ml-20 sticky top-0 z-10" data-id="element-123">
      <div className="flex items-center gap-8 w-full" data-id="element-124">
        {/* Case ID */}
        <div className="flex flex-col" data-id="element-125">
          <div className="flex items-center gap-2 text-text-secondary text-xs uppercase tracking-wider font-bold mb-1" data-id="element-126">
            <Hash className="w-3 h-3" data-id="element-127" /> Case ID
          </div>
          <span className="text-xl font-semibold text-text-primary font-mono" data-id="element-128">
            {caseDetails.id}
          </span>
        </div>

        <div className="h-10 w-px bg-border" data-id="element-129" />

        {/* Location */}
        <div className="flex flex-col" data-id="element-130">
          <div className="flex items-center gap-2 text-text-secondary text-xs uppercase tracking-wider font-bold mb-1" data-id="element-131">
            <MapPin className="w-3 h-3" data-id="element-132" /> Location
          </div>
          <span className="text-xl font-semibold text-text-primary" data-id="element-133">
            {caseDetails.room}
          </span>
        </div>

        <div className="h-10 w-px bg-border" data-id="element-134" />

        {/* Session Time */}
        <div className="flex flex-col" data-id="element-135">
          <div className="flex items-center gap-2 text-text-secondary text-xs uppercase tracking-wider font-bold mb-1" data-id="element-136">
            <Clock className="w-3 h-3" data-id="element-137" /> Session Time
          </div>
          <span className="text-xl font-mono font-semibold text-info" data-id="element-138">
            {elapsed}
          </span>
        </div>
      </div>
    </header>;
}